import { Box, Card, Icon, Text } from '@zillow/constellation-10';
import { IconChevronRightFilled } from '@zillow/constellation-icons';

import { navCardLeadingRowCss, navCardPanelCss, navCardTextColumnCss, navCardTriggerCss } from '../styles';

import { type KeyboardEvent, type ReactNode } from 'react';

export type MultiplexListingNavCardProps = {
  'data-testid': string;
  isNavigationPending: boolean;
  title: ReactNode;
  subtitle: string;
  leading: ReactNode;
  onActivate: () => void;
};

const MultiplexListingNavCard = ({
  'data-testid': dataTestId,
  isNavigationPending,
  title,
  subtitle,
  leading,
  onActivate,
}: MultiplexListingNavCardProps) => {
  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (isNavigationPending) {
      return;
    }
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onActivate();
    }
  };

  return (
    <Box
      role="button"
      tabIndex={isNavigationPending ? -1 : 0}
      aria-busy={isNavigationPending}
      onClick={onActivate}
      onKeyDown={handleKeyDown}
      css={navCardTriggerCss(isNavigationPending)}
    >
      <Card data-testid={dataTestId} tone="neutral" elevated={false} css={navCardPanelCss}>
        <Box css={navCardLeadingRowCss}>
          <Box css={{ flexShrink: 0 }} aria-hidden={true}>
            {leading}
          </Box>
          <Box css={navCardTextColumnCss}>
            <Text textStyle="body-bold" css={{ color: 'text.default' }}>
              {title}
            </Text>
            <Text textStyle="body-sm" css={{ color: 'text.subtle' }}>
              {subtitle}
            </Text>
          </Box>
        </Box>
        <Box css={{ flexShrink: 0 }} aria-hidden={true}>
          <Icon size="md" css={{ color: 'icon.neutral' }} render={<IconChevronRightFilled />} />
        </Box>
      </Card>
    </Box>
  );
};

export default MultiplexListingNavCard;
